
var JWTToken = "03SsP6QcdfdfdZkzGRV38V3A3zUnHRoh9ghhhi0mNJir0";
var recaptchakey = "6LfC7jQbAAAAALH5SP6k8zW6GvKpnXWRMdN-anfH";

var Coins =
	[
		{
			Ticker: "VSOL",
			priceapi: "/coingecko/api/v3/coins/markets?vs_currency=usd&ids=vsolidus&price_change_percentage=24h",
			TokenType: "",
			Name: "VSolidus™"
		},
		{
			Ticker: "VDM",
			priceapi: "/coingecko/api/v3/coins/markets?vs_currency=usd&ids=veridium&price_change_percentage=24h",
			TokenType: "",
			Name: "Veridium"
		},
		{
			Ticker: "WVSOL-BNB",
			priceapi: "/coingecko/api/v3/coins/markets?vs_currency=usd&ids=wrapped-vsolidus&price_change_percentage=24h",
			Name: "WVSolidus™",
			TokenType: "BNB",
		},
		{
			Ticker: "WVSOL-ETH",
			priceapi: "/coingecko/api/v3/coins/markets?vs_currency=usd&ids=wrapped-vsolidus&price_change_percentage=24h",
			Name: "WVSolidus™",
			TokenType: "ETH",
		},
		{
			Ticker: "ETH",
			priceapi: "/coingecko/api/v3/coins/markets?vs_currency=usd&ids=ethereum&price_change_percentage=24h",
			Name: "Ethereum",
			TokenType: "",
		},
		{
			Ticker: "BNB",
			priceapi: "/coingecko/api/v3/coins/markets?vs_currency=usd&ids=binancecoin&price_change_percentage=24h",
			Name: "Binance",
			TokenType: "",
		},

		{
			Ticker: "USDT",
			priceapi: "/coingecko/api/v3/coins/markets?vs_currency=usd&ids=tether&price_change_percentage=24h",
			Name: "Tether",
			TokenType: "",
		},
		{
			Ticker: "BUSD",
			priceapi: "/coingecko/api/v3/coins/markets?vs_currency=usd&ids=binance-usd&price_change_percentage=24h",
			Name: "Binance USD",
			TokenType: "",
		},
		{
			Ticker: "BTC",
			priceapi: "/coingecko/api/v3/coins/markets?vs_currency=usd&ids=bitcoin&price_change_percentage=24h",
			Name: "Bitcoin",
			TokenType: "",
		},
		{
			Ticker: "DOGE",
			priceapi: "/coingecko/api/v3/coins/markets?vs_currency=usd&ids=dogecoin&price_change_percentage=24h",
			Name: "DOGECoin",
			TokenType: "",
		},

	]


//v3
//6LfC7jQbAAAAALH5SP6k8zW6GvKpnXWRMdN-anfH      public
//6LfC7jQbAAAAAFpmdzlFOtAg0pR_qPLsIX0HxSF9      secret

module.exports = { JWTToken, recaptchakey, Coins }
